import { useState, useEffect } from "react";
import "./Modal.css";
import CustomButton from "../../ui/button/Button";
import Select from "react-select";
import {
  porcentajesFilters,
  tenstionFilters,
  demandaFilters,
  defaultCriterios,
} from "../../constants/projects.js";
import Dialog from "@mui/material/Dialog";
import DropdownCaret from "../../ui/select/DropDown";

const ProjectFilterModal = ({
  showModal = true,
  handleCloseModal,
  criterios,
  setCriterios,
  projects,
  permisionarios,
  states,
}) => {
  const [newCriterios, setNewCriterios] = useState({ ...criterios });
  const [demandaInicial, setDemandaInicial] = useState("");
  const [demandaFinal, setDemandaFinal] = useState("");
  const [unidadMedida, setUnidadMedida] = useState("GW");
  const [demandaContratadaInicial, setDemandaContratadaInicial] = useState(0);
  const [demandaContratadaFinal, setDemandaContratadaFinal] = useState(0);

  const toNumberOrNull = (v) => {
    if (v === "" || v === null || v === undefined) return null;
    const n = Number(v.toString().replace(/,/g, "."));
    return Number.isFinite(n) ? n : null;
  };

  useEffect(() => {
    const d1 = toNumberOrNull(demandaInicial);
    const d2 = toNumberOrNull(demandaFinal);

    // si falta alguno → payload null
    if (d1 === null || d2 === null) {
      setDemandaContratadaInicial(0);
      setDemandaContratadaFinal(0);
      setNewCriterios((prev) => ({ ...prev, demandaContratada: null }));
      return;
    }

    // si inicial > final, no actualizamos (o podrías forzar swap si quieres)
    if (d1 > d2) {
      setNewCriterios((prev) => ({ ...prev, demandaContratada: null }));
      return;
    }

    // normalizamos a kW
    let kW1 = d1;
    let kW2 = d2;
    if (unidadMedida === "MW") {
      kW1 *= 1000;
      kW2 *= 1000;
    } else if (unidadMedida === "GW") {
      kW1 *= 1_000_000;
      kW2 *= 1_000_000;
    }

    setDemandaContratadaInicial(kW1);
    setDemandaContratadaFinal(kW2);

    setNewCriterios((prev) => ({
      ...prev,
      demandaContratada: `${kW1}-${kW2}`,
    }));
  }, [demandaInicial, demandaFinal, unidadMedida]);

  function handleSubmit() {
    setCriterios({ ...newCriterios });
    handleCloseModal();
  }

  function handleClear() {
    setDemandaInicial("");
    setDemandaFinal("");
    setUnidadMedida("GW");
    setDemandaContratadaInicial(0);
    setDemandaContratadaFinal(0);
    setNewCriterios({
      ...defaultCriterios,
      proyecto: null,
    });
  }

  useEffect(() => {
    if (!criterios?.demandaContratada) {
      setDemandaInicial("");
      setDemandaFinal("");
      setUnidadMedida("GW");
      setDemandaContratadaInicial(0);
      setDemandaContratadaFinal(0);
    }
    setNewCriterios({ ...criterios });
  }, [criterios]);

  return (
    <Dialog
      className="modal-container-dialog"
      open={showModal}
      onClose={handleCloseModal}
    >
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          gap: "20px",
          width: "100%",
          padding: "20px",
          height: "600px",
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            gap: "20px",
            width: "100%",
          }}
        >
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              gap: "10px",
              width: "48%",
            }}
          >
            <label htmlFor="RPU">RPU</label>
            <input
              type="text"
              id="RPU"
              value={newCriterios.rpu || ""}
              onChange={(e) =>
                setNewCriterios((prev) => ({ ...prev, rpu: e.target.value }))
              }
              placeholder="Filtrar por RPU..."
            />

            <label htmlFor="proyecto">Proyecto</label>
            <Select
              options={[
                { label: "Todos", value: null },
                ...(Array.isArray(projects)
                  ? projects.map((item) => ({
                      ...item,
                      label: item.nombre,
                      value: item.id,
                    }))
                  : []),
              ]}
              onChange={(e) =>
                setNewCriterios((prev) => ({
                  ...prev,
                  proyecto: { id: e.value },
                }))
              }
              placeholder="Proyecto..."
              classNamePrefix="react-select"
              components={{ DropdownIndicator: DropdownCaret }}
              styles={{
                /*   dropdownIndicator: (provided) => ({
                  ...provided,
                  color: "#62C776",
                  cursor: "pointer",
                }),*/
                indicatorSeparator: () => ({ display: "none" }),
                option: (provided, state) => ({
                  ...provided,
                  color: "#000",
                  backgroundColor: state.isSelected ? "#e0e0e0" : "white",
                  cursor: "pointer",
                  fontSize: "14px",
                }),
                control: (provided) => ({
                  ...provided,
                  cursor: "pointer",
                  fontSize: "14px",
                }),
                menu: (provided) => ({
                  ...provided,
                  height: "150px",
                  zIndex: "9999",
                }),
                menuList: (provided) => ({ ...provided, height: "150px" }),
              }}
              value={
                [
                  { label: "Todos", value: null },
                  ...(Array.isArray(projects)
                    ? projects.map((item) => ({
                        ...item,
                        label: item.nombre,
                        value: item.id,
                      }))
                    : []),
                ].find((item) => item.value === newCriterios?.proyecto?.id) ||
                ""
              }
              inputId="proyecto"
            />

            <label htmlFor="nivelTension">Nivel de tensión</label>
            <Select
              options={tenstionFilters}
              onChange={(e) => {
                setNewCriterios((prev) => ({
                  ...prev,
                  nivelTension: e.value,
                }));
              }}
              placeholder="Nivel de tensión..."
              classNamePrefix="react-select"
              components={{ DropdownIndicator: DropdownCaret }}
              styles={{
                /*  dropdownIndicator: (provided) => ({
                  ...provided,
                  color: "#62C776",
                  cursor: "pointer",
                }),*/
                indicatorSeparator: () => ({ display: "none" }),
                option: (provided, state) => ({
                  ...provided,
                  color: "#000",
                  backgroundColor: state.isSelected ? "#e0e0e0" : "white",
                  cursor: "pointer",
                  fontSize: "14px",
                }),
                control: (provided) => ({
                  ...provided,
                  cursor: "pointer",
                  width: "100%",
                  fontSize: "14px",
                }),
                menu: (provided) => ({
                  ...provided,
                  height: "150px",
                  zIndex: "9999",
                }),
                menuList: (provided) => ({
                  ...provided,
                  height: "150px",
                }),
              }}
              value={
                tenstionFilters.find(
                  (item) => item.value === newCriterios?.nivelTension
                ) || tenstionFilters[0]
              }
              inputId="nivelTension"
            />

            <label htmlFor="demandaContratada2">Demanda contratada</label>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              <div
                style={{ display: "flex", gap: "4px", alignItems: "center" }}
              >
                <input
                  type="text"
                  id="demandaContratada2"
                  value={demandaInicial}
                  onChange={(e) => {
                    setDemandaInicial(e.target.value);
                  }}
                  placeholder=""
                  style={{
                    maxWidth: "60px",
                    height: "39px",
                  }}
                />
                <span> - </span>
                <input
                  type="text"
                  id="demandaContratada3"
                  value={demandaFinal}
                  onChange={(e) => {
                    setDemandaFinal(e.target.value);
                  }}
                  placeholder=""
                  style={{ maxWidth: "60px", height: "39px" }}
                />
                <Select
                  options={demandaFilters}
                  onChange={(e) => {
                    setUnidadMedida(e.value);
                  }}
                  placeholder="kw"
                  classNamePrefix="react-select"
                  components={{ DropdownIndicator: DropdownCaret }}
                  styles={{
                    /* dropdownIndicator: (provided) => ({
                      ...provided,
                      color: "#62C776",
                      cursor: "pointer",
                    }),*/
                    indicatorSeparator: () => ({ display: "none" }),
                    option: (provided, state) => ({
                      ...provided,
                      color: "#000",
                      backgroundColor: state.isSelected ? "#e0e0e0" : "white",
                      cursor: "pointer",
                      fontSize: "14px",
                    }),
                    control: (provided) => ({
                      ...provided,
                      cursor: "pointer",
                      width: "100%",
                      fontSize: "14px",
                    }),
                    menu: (provided) => ({
                      ...provided,
                      height: "120px",
                      zIndex: "9999",
                    }),
                    menuList: (provided) => ({
                      ...provided,
                      height: "120px",
                    }),
                  }}
                  value={
                    demandaFilters.find(
                      (item) => item.value === unidadMedida
                    ) || demandaFilters[0]
                  }
                  inputId="demandaContratada"
                />
              </div>
              <span style={{ color: "gray", fontSize: "13px" }}>
                {demandaContratadaInicial
                  .toString()
                  .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                {" - "}
                {demandaContratadaFinal
                  .toString()
                  .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}{" "}
                kW
              </span>
            </div>

            <label htmlFor="porcentajeFotos">Porcentaje de fotos</label>
            <Select
              options={porcentajesFilters}
              onChange={(e) =>
                setNewCriterios((prev) => ({
                  ...prev,
                  porcentajeFotos: e.value,
                }))
              }
              placeholder="% de Fotos..."
              classNamePrefix="react-select"
              components={{ DropdownIndicator: DropdownCaret }}
              styles={{
                /*dropdownIndicator: (provided) => ({
                  ...provided,
                  color: "#62C776",
                  cursor: "pointer",
                }),*/
                indicatorSeparator: () => ({ display: "none" }),
                option: (provided, state) => ({
                  ...provided,
                  color: "#000",
                  backgroundColor: state.isSelected ? "#e0e0e0" : "white",
                  cursor: "pointer",
                  fontSize: "14px",
                }),
                control: (provided) => ({
                  ...provided,
                  cursor: "pointer",
                  width: "100%",
                  fontSize: "14px",
                }),
                menu: (provided) => ({
                  ...provided,
                  height: "150px",
                  zIndex: "9999",
                }),
                menuList: (provided) => ({ ...provided, height: "150px" }),
              }}
              value={
                porcentajesFilters.find(
                  (item) => item.value === newCriterios?.porcentajeFotos
                ) || porcentajesFilters[0]
              }
              inputId="porcentajeFotos"
            />
          </div>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              gap: "10px",
              width: "48%",
            }}
          >
            <label htmlFor="permisionario">Permisionario</label>
            <Select
              options={[
                { label: "Todos", value: null },
                ...(Array.isArray(permisionarios)
                  ? permisionarios.map((item) => ({
                      ...item,
                      label: item.razonSocial,
                      value: item.id,
                    }))
                  : []),
              ]}
              onChange={(e) =>
                setNewCriterios((prev) => ({
                  ...prev,
                  permisionario: { id: e.value },
                }))
              }
              placeholder="Permisionario..."
              classNamePrefix="react-select"
              components={{ DropdownIndicator: DropdownCaret }}
              styles={{
                /*  dropdownIndicator: (provided) => ({
                  ...provided,
                  color: "#62C776",
                  cursor: "pointer",
                }),*/
                indicatorSeparator: () => ({ display: "none" }),
                option: (provided, state) => ({
                  ...provided,
                  color: "#000",
                  backgroundColor: state.isSelected ? "#e0e0e0" : "white",
                  cursor: "pointer",
                  fontSize: "14px",
                }),
                control: (provided) => ({
                  ...provided,
                  cursor: "pointer",
                  fontSize: "14px",
                }),
                menu: (provided) => ({
                  ...provided,
                  height: "150px",
                  zIndex: "9999",
                }),
                menuList: (provided) => ({ ...provided, height: "150px" }),
              }}
              value={
                [
                  { label: "Todos", value: null },
                  ...(Array.isArray(permisionarios)
                    ? permisionarios.map((item) => ({
                        ...item,
                        label: item.razonSocial,
                        value: item.id,
                      }))
                    : []),
                ].find((item) => item.id === newCriterios?.permisionario?.id) ||
                ""
              }
              inputId="permisionario"
            />

            <label htmlFor="nombre">Centro de carga</label>
            <input
              type="text"
              id="nombre"
              value={newCriterios.nombre || ""}
              onChange={(e) =>
                setNewCriterios((prev) => ({
                  ...prev,
                  nombre: e.target.value,
                }))
              }
              placeholder="Filtrar por centro de carga..."
            />

            <label htmlFor="puntoCarga">Punto de carga</label>
            <input
              type="text"
              id="puntoCarga"
              value={newCriterios.puntoCarga || ""}
              onChange={(e) =>
                setNewCriterios((prev) => ({
                  ...prev,
                  puntoCarga: e.target.value,
                }))
              }
              placeholder="Filtrar por punto de carga..."
            />

            <label htmlFor="estado">Estado</label>
            <Select
              options={
                Array.isArray(states)
                  ? states.map((item) => ({
                      ...item,
                      label: item.nombreEstado,
                      value: item.id,
                    }))
                  : []
              }
              onChange={(e) =>
                setNewCriterios((prev) => ({
                  ...prev,
                  estado: { id: e.value },
                }))
              }
              placeholder="Estado..."
              classNamePrefix="react-select"
              components={{ DropdownIndicator: DropdownCaret }}
              styles={{
                /*dropdownIndicator: (provided) => ({
                  ...provided,
                  color: "#62C776",
                  cursor: "pointer",
                }),*/
                indicatorSeparator: () => ({ display: "none" }),
                option: (provided, state) => ({
                  ...provided,
                  color: "#000",
                  backgroundColor: state.isSelected ? "#e0e0e0" : "white",
                  cursor: "pointer",
                  fontSize: "14px",
                }),
                control: (provided) => ({
                  ...provided,
                  cursor: "pointer",
                  width: "100%",
                  fontSize: "14px",
                }),
                menu: (provided) => ({
                  ...provided,
                  height: "150px",
                  zIndex: "9999",
                }),
                menuList: (provided) => ({ ...provided, height: "150px" }),
              }}
              value={
                (Array.isArray(states)
                  ? states.map((item) => ({
                      ...item,
                      label: item.nombreEstado,
                      value: item.id,
                    }))
                  : []
                ).find((item) => item.id === newCriterios?.estado?.id) || ""
              }
              inputId="estado"
            />

            <label htmlFor="porcentajeParametros">
              Porcentaje de parámetros
            </label>
            <Select
              options={porcentajesFilters}
              onChange={(e) =>
                setNewCriterios((prev) => ({
                  ...prev,
                  porcentajeParametros: e.value,
                }))
              }
              placeholder="% de Parámetros..."
              classNamePrefix="react-select"
              components={{ DropdownIndicator: DropdownCaret }}
              styles={{
                /*  dropdownIndicator: (provided) => ({
                  ...provided,
                  color: "#62C776",
                  cursor: "pointer",
                }),*/
                indicatorSeparator: () => ({ display: "none" }),
                option: (provided, state) => ({
                  ...provided,
                  color: "#000",
                  backgroundColor: state.isSelected ? "#e0e0e0" : "white",
                  cursor: "pointer",
                  fontSize: "14px",
                }),
                control: (provided) => ({
                  ...provided,
                  cursor: "pointer",
                  width: "100%",
                  fontSize: "14px",
                }),
                menu: (provided) => ({
                  ...provided,
                  height: "150px",
                  zIndex: "9999",
                }),
                menuList: (provided) => ({ ...provided, height: "150px" }),
              }}
              value={
                porcentajesFilters.find(
                  (item) => item.value === newCriterios?.porcentajeParametros
                ) || porcentajesFilters[0]
              }
              inputId="porcentajeParametros"
            />
          </div>
        </div>
        <div className="d-flex align-items-stretch justify-content-end gap-3">
          <CustomButton
            text={"Cerrar"}
            onClick={handleCloseModal}
            color={"#FFFFFF"}
            border={"none"}
            background={"gray"}
            fontStyle={"normal"}
            fontWeight={700}
            fontSize={"14px"}
            width={"100px"}
            height={"32px"}
            type={"button"}
          />

          <CustomButton
            text={"Limpiar"}
            onClick={handleClear}
            color={"#FFFFFF"}
            border={"none"}
            background={"#223D51"}
            fontStyle={"normal"}
            fontWeight={700}
            fontSize={"14px"}
            width={"100px"}
            height={"32px"}
            type={"button"}
          />

          <CustomButton
            text={"Buscar"}
            color={"#FFFFFF"}
            border={"none"}
            background={"#62C776"}
            fontStyle={"normal"}
            fontWeight={700}
            fontSize={"14px"}
            width={"100px"}
            height={"32px"}
            onClick={handleSubmit}
          />
        </div>
      </div>
    </Dialog>
  );
};

export default ProjectFilterModal;
